import React from 'react';
import { FormGroup, InputGroup, Input, InputGroupText } from 'reactstrap';
import { RebelColors } from '../../../../styles/rebel-experiences';
import { SmallFormFeedback } from '../../../../utils/budget-tool-specific';
import styled from 'styled-components';

const RebelFormInputPP = (props) => {

    const handleInputChange = (value, type) => {
        if (type === "value") {
            const newData = {...props.data};
            newData[props.id].value.value = value;
            props.setData(newData);
        } else if (type === "pp") {
            /*const newData = {...props.data};
            if (newData[props.id].value.pp === "per day") {
                newData[props.id].value.pp = "per person";
            } else if (newData[props.id].value.pp === "per person") {
                newData[props.id].value.pp = "per day";
            }
            props.setData(newData);*/
        }
    }

    return (
        <React.Fragment>
            <FormGroup>
                <RebelLabel for={props.id}>{props.title}</RebelLabel>
                <InputGroup>
                    {props.currency && <RebelInputGroupText invalid={props.data[props.id].invalid}>{props.currency}</RebelInputGroupText> }
                    <RebelInput invalid={props.data[props.id].invalid}
                                    type={props.type}
                                    value={props.data[props.id].value.value}
                                    onChange={e => handleInputChange(e.target.value, "value")}
                                    fontSize={props.fontSize ? props.fontSize : "16px"}>
                        {props.options}
                    </RebelInput>
                    <RebelInputGroupText>
                        per meeting
                                {/*<CheckboxButton onClick={x => handleInputChange(props.data[props.id].value.pp, "pp")}>
                                    per meeting
                                </CheckboxButton>*/}
                            </RebelInputGroupText>
                    <RebelFormFeedback>Required</RebelFormFeedback>
                </InputGroup>
            </FormGroup>
        </React.Fragment>



    )
}

export default RebelFormInputPP;

const RebelLabel = styled.label`
    color: ${RebelColors.primary};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 0.95rem;
    display: block;
`;

const RebelInput = styled(Input)`
    font-size: ${props => props.fontSize ? props.fontSize : "16px"};
    margin: ${props => props.fontSize === "16px" ? "" : "0px 0px"};
    border: 1px solid ${RebelColors.border};
    border-radius: 6px !important;
    background-color: #3b3f45;
    color: ${RebelColors.primary};
    padding: ${props => props.fontSize === "16px" ? "10px 16px" : ""};
    min-height: 46px;
    transition: all 0.3s ease;

    &:focus {
        background-color: #424752;
        border-color: ${RebelColors.gold};
        box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.1);
        color: ${RebelColors.primary};
        outline: none;
    }

    &::placeholder {
        color: ${RebelColors.primaryMuted};
    }

    &:hover {
        border-color: ${RebelColors.borderLight};
        background-color: #424752;
    }
`;

const RebelInputGroupText = styled(InputGroupText)`
    background-color: #2a2e34;
    border: 1px solid ${RebelColors.border};
    color: ${RebelColors.primary};
    border-radius: 6px !important;
    padding: 10px 16px;
    min-height: 46px;
    display: flex;
    align-items: center;
`;

const RebelFormFeedback = styled(SmallFormFeedback)`
    color: ${RebelColors.danger};
`;
